import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "objective-progress-overview";

const keys = addTranslations(RESOURCE_NAME, {
    title: {
        en: "Objective progress overview",
        fr: "Aperçu de l'avancement des objectifs",
    },
    subtheme: {
        en: "Subtheme",
        fr: "Sous-thème",
    },
    validated_objectives: {
        en: "Validated objectives",
        fr: "Objectifs validés",
    },
    validated_objectives_count: {
        en: "{{validated}} of {{total}}",
        fr: "{{validated}} sur {{total}}",
    },
    view_more_subtheme_one: {
        en: "View {{count}} more subtheme",
        fr: "Voir {{count}} sous-thème supplémentaire",
    },
    view_more_subtheme_other: {
        en: "View {{count}} more subthemes",
        fr: "Voir {{count}} sous-thèmes supplémentaires",
    },
    view_less_subtheme: {
        en: "Show less",
        fr: "Afficher moins",
    },
});
export function useObjectiveProgressOverviewTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
